import { useQuery } from '@tanstack/react-query';
import { fetchWeather } from '@/lib/weather';
import type { GeoPoint } from '@/lib/geo';

/** Current weather at the selected location (Open-Meteo, refreshed every 10 min). */
export function useWeather(location: GeoPoint) {
  const keyLat = location.lat.toFixed(2);
  const keyLon = location.lon.toFixed(2);
  return useQuery({
    queryKey: ['weather', keyLat, keyLon],
    queryFn: ({ signal }) => fetchWeather(location, signal),
    staleTime: 10 * 60_000,
    refetchInterval: 10 * 60_000,
    retry: 1,
  });
}
